 const validateColor = (value) => {
    const regex = /^#([0-9a-fA-F]{3}){1,2}$/;
    return regex.test(value);
  };

  export default validateColor;